// @flow
import {useTranslation} from 'gatsby-plugin-react-i18next';
import React, {useEffect} from 'react';

import HeaderSection from '_components/HeaderSection';
import Layout from '_components/Layout';
import PrivacySection from '_components/PrivacySection';
import useAnalytics, {event} from '_hooks/useAnalytics';

const Privacy = (): React$Node => {
  const {t} = useTranslation();
  const {track} = useAnalytics();

  useEffect(() => {
    track({
      group: event.group.Privacy,
      action: event.action.Viewed,
    });
  }, [track]);

  return (
    <Layout floatingNavbar={false} inverseFooter>
      <HeaderSection title={t('Common_PrivacyPolicy')} backgroundColor="#160f10" />
      <PrivacySection />
    </Layout>
  );
};

export default Privacy;
